module.exports = __webpack_public_path__ + "media/images/features/3/album/main-2-518de68208a6319fc89dbd1a1f4a51a5.jpg";